import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import {buttonType} from '../../../utils/commonPropTypes'
import WavyBackground from '../../../components/WavyBackground'
import WidthContainer from '../../../components/WidthContainer'

import illustration from '../images/joinIllustration.svg'
import {QueryedButton} from '../../../components/Button'

const RootContainer = styled(WavyBackground)`
	margin-top: 7.8rem;
`

const phoneBreakpont = '@media only screen and (max-width: 1000px)'

RootContainer.defaultProps = {
	type: 'grayTop',
}

const Inner = styled.div`
	display: flex;
	margin: 1.125rem -3rem -2rem;
	
	> * {
		margin: 2rem 3rem;
		max-width: 30rem;
	}
	
	${phoneBreakpont} {
		flex-direction: column;
		margin-top: 3rem;
		align-items: center;
	}
`

const Column = styled.div`
	flex: 1;
`

const Illustration = styled.img`
	margin-top: -8.0rem;
`
Illustration.defaultProps = {
	src: illustration,
	alt: '',
}

const Title = styled.h1`
	font-size: ${props => props.theme.fontSizes.big30};
`

const Text = styled.div`
	margin-top: 1.25rem;
	margin-bottom: 1.825rem;
`

const JoinSection = ({className, data}) => <RootContainer className={className}>
	<WidthContainer>
		<Inner>
			<Column>
				<Illustration/>
			</Column>
			<Column>
				<Title>{data.title}</Title>
				<Text>{data.text}</Text>
				<QueryedButton data={data.button}/>
			</Column>
		</Inner>
	</WidthContainer>
</RootContainer>

JoinSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		title: PropTypes.string.isRequired,
		text: PropTypes.string.isRequired,
		button: buttonType.isRequired,
	}).isRequired,
}

JoinSection.defaultProps = {
	className: '',
}

export default JoinSection
